var exports = {
  "k": "xdde3148b--4ed16b--container",
};

module.exports = exports;
